import { render, staticRenderFns } from "./ShareSocialMedia.vue?vue&type=template&id=66faaec0"
import script from "./ShareSocialMedia.vue?vue&type=script&lang=js"
export * from "./ShareSocialMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports